import React, { useState } from "react";
import "./Dhenkanal360odiapage.css";
import { useTranslation } from "react-i18next";
export default function Dhenkanal360odiapage() {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    aadhaar: "",
    panchayat: "",
    purpose: "",
    interaction: "",
    overallFeedbackText: "",
    infoFound: "",
    infoReason: "",
    improvement: "",
  });

  const dhenkanal360pageHandleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const dhenkanal360pageHandleSubmit = (e) => {
    e.preventDefault();
    alert("ଫର୍ମ ସଫଳତାର ସହ ଦାଖଲ ହେଲା!");
  };

  return (
    <div className="dhenkanal360page-container">

      {/* HEADER BOX */}
      <div className="dhenkanal360page-header">
        <h2>ଢେଙ୍କାନାଳ ୩୬୦</h2>
        <p>{t("feedback_form_title")}</p>
      </div>

      {/* TOP INFORMATION BLOCK */}
      <div className="dhenkanal360page-top-info">
        <div>
          <strong>କାର୍ଯ୍ୟାଳୟର ନାମ:</strong>
          <p>ବିଡିଓ, କଙ୍କଡାହଡା</p>
        </div>
        <div>
          <strong>ଅଫିସରଙ୍କ ନାମ:</strong>
          <p>ଦେବାଶିଷ ମିଶ୍ର</p>
        </div>
        <div>
          <strong>ବ୍ଲକ୍:</strong>
          <p>କଙ୍କଡାହଡା</p>
        </div>
      </div>

      {/* FORM CARD */}
      <form className="dhenkanal360page-form-card" onSubmit={dhenkanal360pageHandleSubmit}>

        <label>୧. ନାମ :</label>
        <input type="text" name="name" onChange={dhenkanal360pageHandleChange} />

        <label>୨. ମୋବାଇଲ ନମ୍ବର :</label>
        <input type="text" name="mobile" onChange={dhenkanal360pageHandleChange} />

        <label>୩. ଆଧାର ନମ୍ବର :</label>
        <input type="text" name="aadhaar" onChange={dhenkanal360pageHandleChange} />

        <label>୪. ଗ୍ରାମ ପଞ୍ଚାୟତ :</label>
        <input type="text" name="panchayat" onChange={dhenkanal360pageHandleChange} />

        {/* CLEANLINESS */}
        <label>୫. ଆପଣଙ୍କୁ ଆମ କାର୍ଯ୍ୟ ପରିସର ର ସ୍ବଚ୍ଛତା କିପରି ଲାଗିଲା ?</label>
        <div className="dhenkanal360page-radio-group">
          <label>
            <input type="radio" name="cleanliness" value="Satisfied" className="checkbox-margin" />
            ଉନ୍ନତମାନ
          </label>

          <label>
            <input type="radio" name="cleanliness" value="Needs Improvement" className="checkboxmarginodia" />
            <span className="cleanlinesstext">ଉନ୍ନତି ଆବଶ୍ୟକ</span>
          </label>
        </div>

        <label>୬.  ଆପଣଙ୍କ ଗ୍ରସ୍ତର ଉଦ୍ଦେଶ୍ୟ କ'ଣ ଥିଲା?</label>
        <textarea name="purpose" placeholder="ଏଠାରେ ଲେଖନ୍ତୁ..." onChange={dhenkanal360pageHandleChange} />

        <label>୭.  ଆପଣଙ୍କ ଗ୍ରସ୍ତ ସମୟରେ ଆପଣ କାହା ସହିତ ଯୋଗାଯୋଗ କରିଥିଲେ?</label>
        <textarea name="interaction" placeholder="ଏଠାରେ ଲେଖନ୍ତୁ..." onChange={dhenkanal360pageHandleChange} />

        {/* OVERALL SERVICE */}
        <label>୮.  ସାମଗ୍ରିକ ସେବା ସହିତ ଆପଣ କେତେ ସନ୍ତୁଷ୍ଟ ଥିଲେ?</label>
        <div className="dhenkanal360page-radio-group">
          <label>
             <input type="radio" name="overall" value="Good" className="checkbox-margin" />
            ସନ୍ତୁଷ୍ଟ
          </label>

          <label>
            <input type="radio" name="overall" value="Average" className="checkbox-margin" />
            ନିରପେକ୍ଷ
          </label>

          <label>
             <input type="radio" name="overall" value="Needs Improvement" className="checkboxmarginodia" />
            <span className="cleanlinesstext">ଆପଣଙ୍କ ତରଫରୁ କିଛି ପରାମର୍ଶ.</span>
          </label>
        </div>

        <textarea
          name="overallFeedbackText"
          placeholder="ଏଠାରେ ଲେଖନ୍ତୁ..."
          onChange={dhenkanal360pageHandleChange}
        />

      {/* INFORMATION FOUND */}
<label>୯. ଆପଣ ଆବଶ୍ୟକ କରୁଥିବା ସୂଚନା ସହଜରେ ପାଇଲେ କି?</label>

<div className="dhenkanal360page-radio-group">
  <label>
    <input
      type="radio"
      name="infoFound"
      value="Yes"
      className="checkbox-margin"
      onChange={(e) => setFormData({ ...formData, infoFound: e.target.value })}
    />
    ହଁ
  </label>

  <label>
    <input
      type="radio"
      name="infoFound"
      value="No"
      className="checkbox-margin"
      onChange={(e) => setFormData({ ...formData, infoFound: e.target.value })}
    />
    ନା
  </label>
</div>

{/* SHOW ONLY WHEN "No" IS CLICKED */}
{formData.infoFound === "No" && (
  <>
    <label>ଯଦି ନୁହେଁ, ଦୟାକରି କାରଣ ଜଣାନ୍ତୁ :</label>
   
    <textarea
      name="infoReason"
      placeholder="ଏଠାରେ ଲେଖନ୍ତୁ..."
      onChange={dhenkanal360pageHandleChange}
    />
  </>
)}


        <label>୧୦. ଉନ୍ନତ ସେବା ପାଇଁ ଆପଣ କ’ଣ ପରାମର୍ଶ ଦେବେ?</label>
        <textarea
          name="improvement"
          placeholder="ଏଠାରେ ଲେଖନ୍ତୁ..."
          onChange={dhenkanal360pageHandleChange}
        />

        <button className="dhenkanal360page-submitbtn" type="submit">
          ଦାଖଲ କରନ୍ତୁ
        </button>
      </form>
    </div>
  );
}
